import React from 'react';

interface LineWarningIconProps {
  size?: number;
  color?: string;
}

export const LineWarningIcon: React.FC<LineWarningIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" strokeLinejoin="round" />
      <path
        d="M10.2209 7.98777C10.103 6.92738 10.9331 6 12 6C13.0669 6 13.897 6.92738 13.7791 7.98777L13.1104 14.0061C13.0476 14.5719 12.5693 15 12 15C11.4307 15 10.9524 14.5719 10.8896 14.0061L10.2209 7.98777Z"
        fill={color}
      />
      <circle cx="12" cy="17" r="1" fill={color} />
    </svg>
  );
};
